module.exports = __webpack_public_path__ + "img/bet.b1c57d86.png";